// إشعارات الويب/PWA عبر Firebase Cloud Messaging.
// معرّفات تطبيق الويب ومفتاح VAPID عامة بطبيعتها (تُستخدم في المتصفح)، لذا نثبّتها في الكود
// حتى لا يتعطّل التفعيل عندما تُبنى نسخة الإنتاج بدون متغيرات بيئة.
import client from "../api/client";

const CONFIG = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDj9UrGCQGwjvPzPQ3Y4E51DZzAPGXB_88",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "api-helcoo",
  messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID || "280972947208",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:280972947208:web:ac00bfaa9971446b58c6bd",
};
const VAPID =
  process.env.REACT_APP_FIREBASE_VAPID_KEY ||
  "BDi6zbF2kY5Aak3ctG0uDDDuEP67FgGgau8Q59VG8O31Xnjja6PuDkRQhJOc3MG2_57XQXHW29ZnXo8mm071Ia4";

const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent);
const isStandalone = () =>
  window.navigator.standalone === true || window.matchMedia("(display-mode: standalone)").matches;

export const webPushSupported = () =>
  "serviceWorker" in navigator && "Notification" in window && "PushManager" in window;

export const webPushState = () => {
  if (webPushSupported()) return Notification.permission;
  return isIOS() && !isStandalone() ? "ios_install" : "unsupported";
};

// معالج المقدمة: رسائل FCM من نوع data لا تُظهر إشعاراً تلقائياً والتطبيق مفتوح، فنعرضه يدوياً
// عبر عامل الخدمة. بدون هذا كان الإشعار التجريبي "يُرسَل" من الخادم لكن لا يظهر شيء والتطبيق مفتوح.
const attachForeground = (getMessaging, onMessage, app, registration) => {
  onMessage(getMessaging(app), (payload) => {
    const d = payload.data || payload.notification || {};
    registration.showNotification(d.title || "HELCOO", {
      body: d.body || "", icon: "/icon-192.png", badge: "/icon-192.png",
      dir: "rtl", lang: "ar", tag: "helcoo-push", renotify: true,
      data: { url: (d.url) || "/" },
    });
  });
};

export const enableWebPush = async () => {
  if (!webPushSupported()) return { enabled: false, reason: webPushState() };
  if ((await Notification.requestPermission()) !== "granted") return { enabled: false, reason: "denied" };
  const { initializeApp, getApps } = await import("firebase/app");
  const { getMessaging, getToken, onMessage } = await import("firebase/messaging");
  const app = getApps()[0] || initializeApp(CONFIG);
  // عامل خدمة واحد فقط: نستخدم /sw.js (الذي يتضمّن الآن معالج FCM onBackgroundMessage).
  // عامل خدمة واحد يمنع تعارض اشتراكات الدفع ويعيد وصول الإشعارات بالخلفية.
  const registration =
    (await navigator.serviceWorker.getRegistration()) ||
    (await navigator.serviceWorker.register("/sw.js"));
  const token = await getToken(getMessaging(app), { vapidKey: VAPID, serviceWorkerRegistration: registration });
  if (!token) return { enabled: false, reason: "no_token" };
  attachForeground(getMessaging, onMessage, app, registration);
  await client.post("/devices/register", { token, platform: "web" });
  return { enabled: true };
};
